import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import EmployerSearch from "./etqa/employer/EmployerSearch";
import Employer from "./etqa/employer/Employer";
import AssessorSearch from "./etqa/assessor/AssessorSearch";
import AuditTrial from "./etqa/assessor/AuditTrial";
import Assessor from "./etqa/assessor/Assessor";
import BDASearch from "./etqa/bda/BDASearch";
import PersonSearch from "./etqa/person/PersonSearch";
import LearnerSearch from "./etqa/learner/LearnerSearch";
import Learner from "./etqa/learner/Learner";
import LearnerCRM from "./etqa/learner/LearnerCRM";
import Person from "./etqa/person/Person";
import LearnerSkillsProgrammeSearch from "./etqa/learner/LearnerSkillsProgram";
import LearnerBursarySearch from "./etqa/learner/LearnerBursary";
import LearnerUnitStandardSearch from "./etqa/learner/LearnerUnitStandard";
import LearnerCandidacySearch from "./etqa/learner/LearnerCandidacy";
import LearnerInternshipsSearch from "./etqa/learner/LearnerInternships";
import LearnerAETSearch from "./etqa/learner/LearnerAET";
import LearnerFETSearch from "./etqa/learner/LearnerFET";
import LearnerQualificationSearch from "./etqa/learner/LearnerQualification";
import LearnerQualificationUSSearch from "./etqa/learner/LearnerQualificationUSSearch";
import LearnerTradeSearch from "./etqa/learner/LearnerTrade";
import LearnerTradeTestSearch from "./etqa/learner/LearnerTradeTestSearch";
import LearnerLearnershipSearch from "./etqa/learner/LearnerLearnership";
import QCTOLearnerLearnershipSearch from "./etqa/learner/QCTOLearnerLearnership";
import LearnerLearnershipAchievements from "./etqa/learner/LearnerLearnershipAchievement";
import QCTOLearnerLearnershipAchievements from "./etqa/learner/QCTOLearnerLearnershipAchievement";
import LearnerUnitStandardAchievement from "./etqa/learner/LearnerUnitStandardAchievement";
import LearnerQualificationAchievement from "./etqa/learner/LearnerQualificationAchievement";
import LearnerSkillsProgrammeAchievement from "./etqa/learner/LearnerSkillsProgrammeAchievement";
import LearnerLearnershipAssessments from "./etqa/learner/LearnerLearnershipAssessment";
import LearnerQCTOLearnershipAssessments from "./etqa/learner/LearnerQCTOLearnershipAssessments";
import ViewLearnershipAchievementUS from "./etqa/learner/ViewLearnershipAchievementUS";
import QCTOViewLearnershipAchievementUS from "./etqa/learner/QCTOViewLearnershipAchievementUS";
import ViewSkillsProgrammeAchievementUS from "./etqa/learner/ViewSkillsProgrammeAchievementUS";
import ViewQualificationAchievementUS from "./etqa/learner/ViewQualificationAchievementUS";
import ViewLearnershipAssessment from "./etqa/learner/ViewLearnershipAssessment";
import ViewModuleLearnershipAssessment from "./etqa/learner/ViewModuleLearnershipAssessment";
import ViewSkillsProgrammeAssessment from "./etqa/learner/ViewSkillsProgrammeAssessment";
import ViewQualificationAssessment from "./etqa/learner/ViewQualificationAssessment";
import ViewUnitStandardAssessment from "./etqa/learner/ViewUnitStandardAssessment";
import LearnerUnitStandardAssessment from "./etqa/learner/LearnerUnitStandardAssessment";
import LearnerQualificationAssessment from "./etqa/learner/LearnerQualificationAssessment";
import LearnerSkillsProgrammeAssessment from "./etqa/learner/LearnerSkillsProgrammeAssessment";
import LearnerProgrammeGrants from "./etqa/learner/LearnerProgrammeGrants";
import Moderator from "./etqa/moderator/Moderator";
import ModeratorSearch from "./etqa/moderator/ModeratorSearch";
import ModeratorSkillsProgramme from "./etqa/moderator/ModeratorSkillsProgramme";
import ModeratorQualification from "./etqa/moderator/ModeratorQualification";
import Moderatorlearnership from "./etqa/moderator/ModeratorLearnerships";
import ModeratorUnitStandards from "./etqa/moderator/ModeratorUnitStandards";
import ModeratorProviderSearch from "./etqa/moderator/ModeratorProviders";
import ModeratorRegistrationDetails from "./etqa/moderator/ModeratorRegistrationDetails";
import AssessorSkillsProgrammeSearch from "./etqa/assessor/AssessorSkillsProgramme";
import AssessorQualificationSearch from "./etqa/assessor/AssessorQualifications";
import AssessorLearnershipSearch from "./etqa/assessor/AssessorLearnerships";
import AssessorLearnershipUSSearch from "./etqa/assessor/AssessorLearnershipUSSearch";
import ModeratorRegistrationHistory from "./etqa/moderator/RegistrationHistory";
import ModeratorCRM from "./etqa/moderator/ModeratorCRM";
import UploadPerson from "./etqa/bulkupload/uploadPerson";
import UploadLearnership from "./etqa/bulkupload/uploadLearnership";
import UploadSkills from "./etqa/bulkupload/uploadSkills";
import UploadBursaries from "./etqa/bulkupload/uploadBursaries";
import UploadInternship from "./etqa/bulkupload/uploadInternship";
import UploadAET from "./etqa/bulkupload/uploadAET";
import UploadCandidacy from "./etqa/bulkupload/uploadCandidacy";
import UploadFET from "./etqa/bulkupload/uploadFET";
import UploadQualification from "./etqa/bulkupload/uploadQualification";
import UploadUnitStandard from "./etqa/bulkupload/uploadUnitStandard";
import UploadAchievement from "./etqa/bulkupload/uploadAchievement";
import AssessorRegistrationHistory from "./etqa/assessor/RegistrationHistory";
import LearnerSkillsProgram from "./etqa/learner/LearnerSkillsProgram";
import AddLearnerSkillsProgram from "./etqa/learner/AddLearnerSkillsProgram";
import AddLearnerBursary from "./etqa/learner/AddLearnerBursary";
import AddLearnerInternships from "./etqa/learner/AddLearnerInternships";
import AddLearnerLearnership from "./etqa/learner/AddLearnerLearnership";
import QCTOAddLearnerLearnership from "./etqa/learner/QCTOAddLearnerLearnership";
import AddLearnerQualification from "./etqa/learner/AddLearnerQualification";
import AddLearnerUnitStandard from "./etqa/learner/AddLearnerUnitStandard";
import AddLearnerAET from "./etqa/learner/AddLearnerAET";
import AddLearnerFET from "./etqa/learner/AddLearnerFET";
import AddLearnerCandidacy from "./etqa/learner/AddLearnerCandidacy";
import AddLearnerTrade from "./etqa/learner/AddLearnerTrade";
import AssessorUnitStandards from "./etqa/assessor/AssessorUnitStandards";
import AssessorProviderSearch from "./etqa/assessor/AssessorProvider";
import AssessorRegistrationDetails from "./etqa/assessor/AssessorRegistrationDetails";
import AssessorCRM from "./etqa/assessor/AssessorCRM";
import EmployerCRM from "./etqa/employer/EmployerCRM";

import OrganisationCRM from "./skills/organisation/OrganisationCRM";

import GrantSetupSearch from "./etqa/grants/grantsetup/GrantSetupSearch";
import AddEditTranche from "./etqa/grants/grantsetup/AddEditTranche";
import TrancheDetails from "./etqa/grants/grantsetup/TrancheDetails";
import ProcessingNav from "./etqa/grants/grantprocessing/ProcessingNav";
import GenerateClaimSearch from "./etqa/grants/grantprocessing/GenerateClaimSearch";
import ApproveClaimSearch from "./etqa/grants/grantprocessing/ApproveClaimSearch";
import GrantClaimFormReversalSearch from "./etqa/grants/grantprocessing/GrantClaimFormReversalSearch";
import DownloadClaimSearch from "./etqa/grants/grantprocessing/DownloadClaimSearch";
import GenerateBatchSearch from "./etqa/grants/grantprocessing/GenerateBatchSearch";
import DownloadBatchSearch from "./etqa/grants/grantprocessing/DownloadBatchSearch";
import AXProcessorSearch from "./etqa/grants/grantprocessing/AXProcessorSearch";
import GrantReversalsSearch from "./etqa/grants/grantprocessing/GrantReversalsSearch";
import BulkGrantAssociation from "./etqa/grants/grantassociations/BulkGrantAssociation";
import BulkGrantDeAssociation from "./etqa/grants/grantassociations/BulkGrantDiAssociation";

import ProviderCRM from "./etqa/provider/ProviderCRM";
import AssessorIDDocument from "./etqa/assessor/AssessorIDDocument";

import OnlineRegistrationTypeSelect from "./etqa/onlineRegistration/OnlineRegistrationTypeSelect";
import OnlineRegistrationSecondryTypeSelect from "./etqa/onlineRegistration/OnlineRegistrationSecondryTypeSelect";
import AddOnlineAssessorFlow from "./etqa/onlineRegistration/assessor/AddOnlineAssessorFlow";
import OnlineAssessorApprovalSearch from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalSearch";
import AssessorApproval from "./etqa/onlineRegistration/assessor/AssessorApproval";
import OnlineAssessorApprovalQualificationScope from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalQualificationScope";
import OnlineAssessorApprovalSkillsProgrammeScope from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalSkillsProgrammeScope";
import OnlineAssessorApprovalDocuments from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalDocuments";
import OnlineAssessorDetailsVerification from "./etqa/onlineRegistration/assessor/OnlineAssessorDetailsVerification";
import OnlineAssessorApprovalLearnershipScope from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalLearnershipScope";

import AddOnlineModeratorFlow from "./etqa/onlineRegistration/moderator/AddOnlineModeratorFlow";
import OnlineModeratorApprovalSearch from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalSearch";
import ModeratorApproval from "./etqa/onlineRegistration/moderator/ModeratorApproval";
import OnlineModeratorApprovalQualificationScope from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalQualificationScope";
import OnlineModeratorApprovalSkillsProgrammeScope from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalSkillsProgrammeScope";
import OnlineModeratorApprovalDocuments from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalDocuments";
import OnlineModeratorDetailsVerification from "./etqa/onlineRegistration/moderator/OnlineModeratorDetailsVerification";
import OnlineModeratorApprovalLearnershipScope from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalLearnershipScope";

import AddOnlineProviderFlow from "./etqa/onlineRegistration/provider/AddOnlineProviderFlow";
import OnlineProviderApprovalSearch from "./etqa/onlineRegistration/provider/OnlineProviderApprovalSearch";
import ProviderApproval from "./etqa/onlineRegistration/provider/ProviderApproval";
import OnlineProviderApprovalQualificationScope from "./etqa/onlineRegistration/provider/OnlineProviderApprovalQualificationScope";
import OnlineProviderApprovalSkillsProgrammeScope from "./etqa/onlineRegistration/provider/OnlineProviderApprovalSkillsProgrammeScope";
import OnlineProviderApprovalDocuments from "./etqa/onlineRegistration/provider/OnlineProviderApprovalDocuments";
import OnlineProviderDetailsVerification from "./etqa/onlineRegistration/provider/OnlineProviderDetailsVerification";
import OnlineProviderApprovalLearnershipScope from "./etqa/onlineRegistration/provider/OnlineProviderApprovalLearnershipScope";

import ProviderSearch from "./etqa/provider/ProviderSearch";
import Provider from "./etqa/provider/Provider";
import Outcome from "./etqa/program/Outcome";
import ProviderMonitoringAndEvaluation from "./etqa/provider/ProviderMonitoringAndEvaluation";
import ProviderTrade from "./etqa/provider/ProviderTrade";
import ProviderContact from "./etqa/provider/ProviderContact";
import ProviderUsers from "./etqa/provider/ProviderUsers";
import ProviderSiteVisitsSearch from "./etqa/provider/ProviderSiteVisits";
import ProviderAccreditation from "./etqa/provider/ProviderAccreditation";
import ProviderAccreditationHistory from "./etqa/provider/ProviderAccreditationHistory";
import ProviderLearner from "./etqa/provider/ProviderLearner";
import ProviderUnitStandards from "./etqa/provider/ProviderUnitStandards";
import ProviderQualificationSearch from "./etqa/provider/ProviderQualificationsSearch";
import ProviderSkillsProgrammeSearch from "./etqa/provider/ProviderSkillsProgrammeSearch";
import ProviderSkillsProgrammeUSSearch from "./etqa/provider/ProviderSkillsProgrammeUSSearch";
import ProviderLearnershipUSSearch from "./etqa/provider/ProviderLearnershipUSSearch";
import ProviderQualificationUSSearch from "./etqa/provider/ProviderQualificationUSSearch";
import ProviderLearnershipSearch from "./etqa/provider/ProviderLearnershipSearch";
import ProviderAssessorSearch from "./etqa/provider/ProviderAssessors";
import ProviderModeratorSearch from "./etqa/provider/ProviderModeratorSearch";
import ExternalProviderSearch from "./etqa/externalmoderator/ExternalModeratorSearch";
import UnitStandardSetupSearch from "./etqa/program/UnitStandardSetupSearch";
import UnitStandardSetup from "./etqa/program/UnitStandardSetup";
import QualificationSetupSearch from "./etqa/program/QualificationSetupSearch";
import QualificationSetup from "./etqa/program/QualificationSetup";
import LearnershipSetupSearch from "./etqa/program/LearnershipSetupSearch";
import AETSetupSearch from "./etqa/program/AET/AETSetupSearch";
import AETSetup from "./etqa/program/AET/AETSetup";
import TradeSetupSearch from "./etqa/program/Trade/TradeSetupSearch";
import TradeSetup from "./etqa/program/Trade/TradeSetup";
import LearnershipUnitStandardSearch from "./etqa/program/LearnershipUnitStandardSearch";
import LearnershipSetup from "./etqa/program/LearnershipSetup";
import SAQAXMLImport from "./etqa/program/SAQAXMLImport";
import ModuleSetup from "./etqa/program/ModuleSetup";
import ModuleSetupSearch from "./etqa/program/ModuleSetupSearch";
import ProviderModuleQualificationsSearch from "./etqa/provider/ProviderModuleQualificationsSearch";
import QualificationModuleSearch from "./etqa/program/QualificationModuleSearch";
import ShortCourseSetupSearch from "./etqa/program/ShortCourseSetupSearch";
import SkillsProgramSetupSearch from "./etqa/program/SkillsProgramSetupSearch";
import SkillsProgramSetup from "./etqa/program/SkillsProgramSetup";
import ArtisansSetupSearch from "./etqa/program/ArtisansSetupSearch";
import EmployerLearnerSearch from "./etqa/employer/EmployerLearnerSearch";
import EmployerUserSearch from "./etqa/employer/EmployerUserSearch";
import EmployerContactSearch from "./etqa/employer/EmployerContactSearch";
import EmployerResearchVisitSearch from "./etqa/employer/EmployerResearchVisitSearch";
import ResearchVisitDashboardSearch from "./ResearchVisitDashboard/ResearchVisitDashboardSearch";
import SurveySearch from "./etqa/research/SurveySearch";
import AddSurvey from "./etqa/research/AddSurvey";
import ViewSurvey from "./etqa/research/ViewSurvey";
import SurveyDashboardSearch from "./SurveyDashboard/SurveyDashboardSearch";
import AddLearnerFlow from "./etqa/learner/AddLearnerFlow";
import AddPersonFlow from "./etqa/person/AddPersonFlow";
import AddAssessorFlow from "./etqa/assessor/AddAssessorFlow";
import AddModeratorFlow from "./etqa/moderator/AddModeratorFlow";
import Dashboard from "./widgets/Dashboard";
import SDFDashboard from "./Dashboards/SDFDashboard";
import StakeholderDashboard from "./Dashboards/StakeholderDashboard";
import SkillsDashboard from "./Dashboards/SkillsDashboard";
import { Route } from "react-router-dom";
import QualificationUnitStandardSearch from "./etqa/program/QualificationUnitStandardSearch";
import SkillsUnitStandardSearch from "./etqa/program/SkillsUnitStandardSearch";
import SDFSearch from "./skills/sdf/SDFSearch";
import RoleMaintenanceSearch from "./maintenance/Role/RoleSearch";
import UserMaintenanceSearch from "./maintenance/User/UserSearch";
import UserDetailsMaintenanceSearch from "./maintenance/User/UserDetail";

import UserRoleSearch from "./maintenance/User/UserRoles";
import ClientsEmailsSearch from "./maintenance/Clients/ClientsEmailsSearch";
import EmailAdd from "./maintenance/Clients/EmailAdd";

import SkillsLetterCreationSearch from "./maintenance/Skills/SkillsLetterCreationSearch";
import SkillsLetterCreation from "./maintenance/Skills/SkillsLetterCreation";
import SkillsQueryReasonSearch from "./maintenance/Skills/SkillsQueryReasonSearch";
import SkillsQueryReason from "./maintenance/Skills/SkillsQueryReason";
import SkillsRejectionReasonSearch from "./maintenance/Skills/SkillsRejectionReasonSearch";
import SkillsRejectionReason from "./maintenance/Skills/SkillsRejectionReason";
import SkillsTNumberConversionSearch from "./maintenance/Skills/SkillsTNumberConversionSearch";
import SkillsTNumberConversion from "./maintenance/Skills/SkillsTNumberConversion";

import CreateBenefitsDescriptionSearch from "./maintenance/Benefits/CreateBenefitsDescriptionSearch";
import BenefitsDescriptionsSearch from "./maintenance/Benefits/BenefitsDescriptionsSearch";
import CreateInterventionTitles from "./maintenance/Benefits/CreateInterventionTitles";
import BenefitsTargetAddFormSearch from "./maintenance/Benefits/BenefitsTargetAddFormSearch";
import BenefitsTargetsSearch from "./maintenance/Benefits/BenefitsTargetsSearch";
import InterventionTitlesSearch from "./maintenance/Benefits/InterventionTitlesSearch";

import LinkingSearch from "./maintenance/Benefits/LinkingSearch";
import BenefitsUpload from "./maintenance/Benefits/BenefitsUpload";
import CreateLinkingSearch from "./maintenance/Benefits/CreateLinkingSearch";

import DGLetterCreation from "./maintenance/DG/DGLetterCreation";
import DGLetterCreationSearch from "./maintenance/DG/DGLetterCreationSearch";
import DGQueryReasonSearch from "./maintenance/DG/DGQueryReasonSearch";
import DGQueryReason from "./maintenance/DG/DGQueryReason";
import DGRejectionReasonSearch from "./maintenance/DG/DGRejectionReasonSearch";
import DGRejectionReason from "./maintenance/DG/DGRejectionReason";

import Role from "./maintenance/Role/Role";
import RolePermissionSearch from "./maintenance/Role/RolePermissionSearch";
import RolePermission from "./maintenance/Role/RolePermission";
import SDF from "./skills/sdf/SDF";
import SDFOrganisationDetails from "./skills/sdf/SDFOrganisations";

import DGOrganisationSearch from "./dg/organisation/DGOrganisationSearch";
import DGOrganisation from "./dg/organisation/DGOrganisation";
import StakeholderSearch from "./dg/stakeholder/StakeholderSearch";
import Stakeholder from "./dg/stakeholder/Stakeholder";
import StakeholderOrganisationDetails from "./dg/stakeholder/StakeholderOrganisationDetails";
import DGOrganisationContact from "./dg/organisation/DGOrganisationContact";
import DGDocumentsUpload from "./dg/documentuploads/DGDocumentUploads";
import OrganisationStakeholder from "./dg/organisation/OrganisationStakeholder";
import DGOrganisationCRM from "./dg/organisation/DGOrganisationCRM";

import Organisation from "./skills/organisation/Organisation";
import OrganisationSearch from "./skills/organisation/OrganisationSearch";
import OrganisationContact from "./skills/organisation/OrganisationContact";
import OrganisationBankingDetails from "./skills/organisation/OrganisationBankingDetails";
import ChildOrganisationSearch from "./skills/organisation/ChildOrganisationSearch";
import ChildOrganisation from "./skills/organisation/ChildOrganisation";
import OrganisationCFODetails from "./skills/organisation/OrganisationCFODetails";
import TrainingCommitteeSearchRecord from "./skills/organisation/TrainingCommitteeRecords";
import TrainingCommittee from "./skills/organisation/TrainingCommittee";
import UnionSearchRecord from "./skills/organisation/UnionRecords";

import WspAtrForms from "./skills/WspAtrForms/WspAtrForms";
import EmploymentNumberForm2022 from "./skills/WspAtrForms/Forms/2022/EmploymentNumber";
import EmploymentNumberSmallForm2022 from "./skills/WspAtrForms/Forms/2022/EmploymentNumberSmall";
import AnnualTrainingReportForm2022 from "./skills/WspAtrForms/Forms/2022/AnnualTrainingReport";
import ActualPivotalTrainingForm2022 from "./skills/WspAtrForms/Forms/2022/ActualPivotalTraining";
import WorkplaceSkillsPlanForm2022 from "./skills/WspAtrForms/Forms/2022/WorkplaceSkillsPlan";
import QualificationProfileForm2022 from "./skills/WspAtrForms/Forms/2022/QualificationProfile";
import PlannedPivotalTrainingForm2022 from "./skills/WspAtrForms/Forms/2022/PlannedPivotalTraining";
import ActualBeneficiariesTrainingForm2022 from "./skills/WspAtrForms/Forms/2022/ActualBeneficiariesTraining";
import ActualAETForm2022 from "./skills/WspAtrForms/Forms/2022/ActualAET";
import PlannedBeneficiariesTrainingForm2022 from "./skills/WspAtrForms/Forms/2022/PlannedBeneficiariesTraining";
import ProvincialDetailsForm2022 from "./skills/WspAtrForms/Forms/2022/ProvincialDetails";
import PlannedAETForm2022 from "./skills/WspAtrForms/Forms/2022/PlannedAET";
import ImpactAssessmentForm2022 from "./skills/WspAtrForms/Forms/2022/ImpactAssessment";
import HardToFillVacanciesForm2022 from "./skills/WspAtrForms/Forms/2022/HardToFillVacancies";
import CheckListForm2022 from "./skills/WspAtrForms/Forms/2022/CheckList";
import EmploymentNumberForm2023 from "./skills/WspAtrForms/Forms/2023/EmploymentNumber";
import EmploymentNumberSmallForm2023 from "./skills/WspAtrForms/Forms/2023/EmploymentNumberSmall";
import AnnualTrainingReportForm2023 from "./skills/WspAtrForms/Forms/2023/AnnualTrainingReport";
import ActualPivotalTrainingForm2023 from "./skills/WspAtrForms/Forms/2023/ActualPivotalTraining";
import WorkplaceSkillsPlanForm2023 from "./skills/WspAtrForms/Forms/2023/WorkplaceSkillsPlan";
import QualificationProfileForm2023 from "./skills/WspAtrForms/Forms/2023/QualificationProfile";
import PlannedPivotalTrainingForm2023 from "./skills/WspAtrForms/Forms/2023/PlannedPivotalTraining";
import ActualBeneficiariesTrainingForm2023 from "./skills/WspAtrForms/Forms/2023/ActualBeneficiariesTraining";
import ActualAETForm2023 from "./skills/WspAtrForms/Forms/2023/ActualAET";
import PlannedBeneficiariesTrainingForm2023 from "./skills/WspAtrForms/Forms/2023/PlannedBeneficiariesTraining";
import ProvincialDetailsForm2023 from "./skills/WspAtrForms/Forms/2023/ProvincialDetails";
import PlannedAETForm2023 from "./skills/WspAtrForms/Forms/2023/PlannedAET";
import ImpactAssessmentForm2023 from "./skills/WspAtrForms/Forms/2023/ImpactAssessment";
import HardToFillVacanciesForm2023 from "./skills/WspAtrForms/Forms/2023/HardToFillVacancies";
import CheckListForm2023 from "./skills/WspAtrForms/Forms/2023/CheckList";
import WspAtrDashboard from "./skills/WspAtrForms/WspAtrDashboard";
import WspAtrDocumentsUpload from "./skills/WspAtrForms/DocumentsUpload";
import WspAtrVerification from "./skills/WspAtrForms/WSPATRVerificationSearch";
import WSPATRVerificationMain from "./skills/WspAtrForms/WSPATRVerificationMain";
import WSPATREvaluation from "./skills/WspAtrForms/WSPATREvaluationSearch";
import WSPATREvaluationMain from "./skills/WspAtrForms/WSPATREvaluationMain";
import Approval from "./skills/WspAtrForms/Approval";
import WspAtrApproval from "./skills/WspAtrForms/WSPATRApprovalSearch";
import WSPATRApprovalMain from "./skills/WspAtrForms/WSPATRApprovalMain";
import Verification from "./skills/WspAtrForms/Verification";
import Evaluation from "./skills/WspAtrForms/Evaluation";
import Feedback from "./skills/organisation/Stakeholderfeedback";
import RequestExtension from "./skills/WspAtrForms/Extension";
import LodgeApeal from "./skills/WspAtrForms/LodgeApeal";

/*WSP/ATR Forms 2024*/
import EmploymentNumberForm2024 from "./skills/WspAtrForms/Forms/2024/EmploymentNumber";
import EmploymentNumberSmallForm2024 from "./skills/WspAtrForms/Forms/2024/EmploymentNumberSmall";
import AnnualTrainingReportForm2024 from "./skills/WspAtrForms/Forms/2024/AnnualTrainingReport";
import ActualPivotalTrainingForm2024 from "./skills/WspAtrForms/Forms/2024/ActualPivotalTraining";
import WorkplaceSkillsPlanForm2024 from "./skills/WspAtrForms/Forms/2024/WorkplaceSkillsPlan";
import QualificationProfileForm2024 from "./skills/WspAtrForms/Forms/2024/QualificationProfile";
import PlannedPivotalTrainingForm2024 from "./skills/WspAtrForms/Forms/2024/PlannedPivotalTraining";
import ActualBeneficiariesTrainingForm2024 from "./skills/WspAtrForms/Forms/2024/ActualBeneficiariesTraining";
import ActualAETForm2024 from "./skills/WspAtrForms/Forms/2024/ActualAET";
import PlannedBeneficiariesTrainingForm2024 from "./skills/WspAtrForms/Forms/2024/PlannedBeneficiariesTraining";
import ProvincialDetailsForm2024 from "./skills/WspAtrForms/Forms/2024/ProvincialDetails";
import PlannedAETForm2024 from "./skills/WspAtrForms/Forms/2024/PlannedAET";
import ImpactAssessmentForm2024 from "./skills/WspAtrForms/Forms/2024/ImpactAssessment";
import HardToFillVacanciesForm2024 from "./skills/WspAtrForms/Forms/2024/HardToFillVacancies";
import CheckListForm2024 from "./skills/WspAtrForms/Forms/2024/CheckList";

/*WSP/ATR Forms 2025*/
import EmploymentNumberForm2025 from "./skills/WspAtrForms/Forms/2025/EmploymentNumber";
import EmploymentNumberSmallForm2025 from "./skills/WspAtrForms/Forms/2025/EmploymentNumberSmall";
import AnnualTrainingReportForm2025 from "./skills/WspAtrForms/Forms/2025/AnnualTrainingReport";
import ActualPivotalTrainingForm2025 from "./skills/WspAtrForms/Forms/2025/ActualPivotalTraining";
import WorkplaceSkillsPlanForm2025 from "./skills/WspAtrForms/Forms/2025/WorkplaceSkillsPlan";
import QualificationProfileForm2025 from "./skills/WspAtrForms/Forms/2025/QualificationProfile";
import PlannedPivotalTrainingForm2025 from "./skills/WspAtrForms/Forms/2025/PlannedPivotalTraining";
import ActualBeneficiariesTrainingForm2025 from "./skills/WspAtrForms/Forms/2025/ActualBeneficiariesTraining";
import ActualAETForm2025 from "./skills/WspAtrForms/Forms/2025/ActualAET";
import PlannedBeneficiariesTrainingForm2025 from "./skills/WspAtrForms/Forms/2025/PlannedBeneficiariesTraining";
import ProvincialDetailsForm2025 from "./skills/WspAtrForms/Forms/2025/ProvincialDetails";
import PlannedAETForm2025 from "./skills/WspAtrForms/Forms/2025/PlannedAET";
import ImpactAssessmentForm2025 from "./skills/WspAtrForms/Forms/2025/ImpactAssessment";
import HardToFillVacanciesForm2025 from "./skills/WspAtrForms/Forms/2025/HardToFillVacancies";
import CheckListForm2025 from "./skills/WspAtrForms/Forms/2025/CheckList";

/*WSP/ATR Forms 2026*/
import EmploymentNumberForm2026 from "./skills/WspAtrForms/Forms/2026/EmploymentNumber";
import EmploymentNumberSmallForm2026 from "./skills/WspAtrForms/Forms/2026/EmploymentNumberSmall";
import AnnualTrainingReportForm2026 from "./skills/WspAtrForms/Forms/2026/AnnualTrainingReport";
import ActualPivotalTrainingForm2026 from "./skills/WspAtrForms/Forms/2026/ActualPivotalTraining";
import WorkplaceSkillsPlanForm2026 from "./skills/WspAtrForms/Forms/2026/WorkplaceSkillsPlan";
import QualificationProfileForm2026 from "./skills/WspAtrForms/Forms/2026/QualificationProfile";
import PlannedPivotalTrainingForm2026 from "./skills/WspAtrForms/Forms/2026/PlannedPivotalTraining";
import ActualBeneficiariesTrainingForm2026 from "./skills/WspAtrForms/Forms/2026/ActualBeneficiariesTraining";
import ActualAETForm2026 from "./skills/WspAtrForms/Forms/2026/ActualAET";
import PlannedBeneficiariesTrainingForm2026 from "./skills/WspAtrForms/Forms/2026/PlannedBeneficiariesTraining";
import ProvincialDetailsForm2026 from "./skills/WspAtrForms/Forms/2026/ProvincialDetails";
import PlannedAETForm2026 from "./skills/WspAtrForms/Forms/2026/PlannedAET";
import ImpactAssessmentForm2026 from "./skills/WspAtrForms/Forms/2026/ImpactAssessment";
import HardToFillVacanciesForm2026 from "./skills/WspAtrForms/Forms/2026/HardToFillVacancies";
import CheckListForm2026 from "./skills/WspAtrForms/Forms/2026/CheckList";

import OrganisationSDF from "./skills/organisation/OrganisationSDF";
import OrganisationGrantsLevies from "./skills/organisation/OrganisationGrantsLevies";
import Levies from "./skills/organisation/Levies";
import Grants from "./skills/organisation/Grants";
import DiscretionaryGrants from "./skills/organisation/DiscretionaryGrants";
import InterSetaTransfer from "./skills/organisation/InterSetaTransfer";
import SDFComplianceLetter from "./skills/organisation/OrganisationSDFComplianceLetter";

import EmployerFileImport from "./skills/EmployerFileImport/EmployerFileImport";

import ETQAReportSearch from "./reports/etqa/ETQAReportSearch";
import ETQAReport from "./reports/etqa/ETQAReport";
import SkillsReportSearch from "./reports/skills/SkillsReportSearch";
import SkillsReport from "./reports/skills/SkillsReport";
import MasterFileSearch from "./reports/masterfiles/MasterFileSearch";
import MasterFile from "./reports/masterfiles/MasterFile";
import SETMISFileSearch from "./reports/setmisfiles/SETMISFileSearch";
import SETMISFile from "./reports/setmisfiles/SETMISFile";
import DGReportSearch from "./reports/dg/DGReportSearch";
import DGReport from "./reports/dg/DGReport";
import CustomReports from "./reports/customreports/CustomReports";
import CustomReportsV2 from "./reports/customreports/CustomReportsV2";
import AdminReportSearch from "./reports/admin/AdminReportSearch";
import AdminReport from "./reports/admin/AdminReport";
import ProviderReportSearch from "./reports/provider/ProviderReportSearch";
import ProviderReport from "./reports/provider/ProviderReport";
import EmployerReportSearch from "./reports/employer/EmployerReportSearch";
import EmployerReport from "./reports/employer/EmployerReport";

import ProviderDocuments from "./etqa/approval and certification/ProviderDocuments";
import AssessorDocuments from "./etqa/approval and certification/AssessorDocuments";
import ModeratorDocuments from "./etqa/approval and certification/ModeratorDocuments";
import LearnerDocuments from "./etqa/approval and certification/LearnerDocuments";
import BulkApproval from "./etqa/approval and certification/BulkApproval";
import ExpiryNotification from "./etqa/expiry notification/ExpiryNotification";
import LearnerEndorsementLetter from "./etqa/approval and certification/LearnerEndorsementLetter";
import POR from "./etqa/proof of registration/ProofOfRegistrationSearch";

import Test from "./Test";
import TestTableDemo from "./test components/TestTableDemo";

import DGApplication from "./dg/application/DGApplication";
import DGApplicationDashboard from "./dg/application/DGApplicationDashboard";
import DGForms from "./dg/application/Forms/DGForms";
import DGVerificationSearch from "./dg/verification/DGVerificationSearch";
import DGVerificationMain from "./dg/verification/DGVerificationMain";
import DGEvaluationSearch from "./dg/evaluation/DGEvaluationSearch";
import DGEvaluationMain from "./dg/evaluation/DGEvaluationMain";
import DGApprovalSearch from "./dg/approval/DGApprovalSearch";
import DGApprovalMain from "./dg/approval/DGApprovalMain";
import DGContracts from "./dg/contracts/DGContracts";

//DG Forms 2022
import ArtisanForm2022 from "./dg/application/Forms/2022/Artisan";
import AETForm2022 from "./dg/application/Forms/2022/AET";
import BursaryForm2022 from "./dg/application/Forms/2022/Bursary";
import LearnershipForm2022 from "./dg/application/Forms/2022/Learnership";
import CandidacyForm2022 from "./dg/application/Forms/2022/Candidacy";
import TVETForm2022 from "./dg/application/Forms/2022/TVET";
import LearnershipRPLForm2022 from "./dg/application/Forms/2022/LearnershipRPL";
import InternshipForm2022 from "./dg/application/Forms/2022/Internship";
import SkillsProgrammeForm2022 from "./dg/application/Forms/2022/SkillsProgramme";
import SkillsProgrammeEUForm2022 from "./dg/application/Forms/2022/SkillsProgrammeEU";
import WorkExperienceForm2022 from "./dg/application/Forms/2022/WorkExperience";

//DG Forms 2024
import BursaryForm2024 from "./dg/application/Forms/2024/Bursary";
//DG Forms 2026
import ArtisanForm2026 from "./dg/application/Forms/2026/Artisan";
import AETForm2026 from "./dg/application/Forms/2026/AET";
import BursaryForm2026 from "./dg/application/Forms/2026/Bursary";
import LearnershipForm2026 from "./dg/application/Forms/2026/Learnership";
import CandidacyForm2026 from "./dg/application/Forms/2026/Candidacy";
import TVETForm2026 from "./dg/application/Forms/2026/TVET";
import LearnershipRPLForm2026 from "./dg/application/Forms/2026/LearnershipRPL";
import InternshipForm2026 from "./dg/application/Forms/2026/Internship";
import SkillsProgrammeEUForm2026 from "./dg/application/Forms/2026/SkillsProgrammeEU";
import WorkExperienceForm2026 from "./dg/application/Forms/2026/WorkExperience";


/*QALP Dashboard*/
import QALPDashboard from "./Dashboards/QALPDashboard";

/*MG DASHBOARD*/
import MGDashboard from "./Dashboards/MGDashboard";

/*DG DASHBOARD*/
import DGDashboard from "./Dashboards/DGDashboard";

/*APP DASHBOARD*/
import APPDashboard from "./Dashboards/APPDashboard";

/*APP Summary DASHBOARD*/
import APPSummaryDashboard from "./Dashboards/APPSummaryDashboard";


//Helpdesk
import HelpdeskRequestSearch from "./helpdesk/Request/HelpdeskRequestSearch";
import HelpdeskRequest from "./helpdesk/Request/HelpdeskRequest";
import HelpDeskReport from "./helpdesk/Report/HelpDeskReport";

import AudienceOptions from "./maintenance/CRM/AudienceOptions";
import BulkEmailSearch from "./maintenance/CRM/BulkEmailSearch";
import BulkEmailDetail from "./maintenance/CRM/BulkEmailDetail"; 

//Projects
import ProjectsSearch from "./projects/ProjectsSearch"
import NewProject from "./projects/NewProject"
import ProjectDetail from "./projects/ProjectDetail"
import ProjectMilestone from "./projects/ProjectMilestone"
import CaptureMilestone from "./projects/CaptureMilestone"
import ProjectBudget from "./projects/ProjectBudget"
import ProjectGrant from "./projects/ProjectGrant"
import ProjectBeneficiaries from "./projects/ProjectBeneficiaries"
import ProjectBeneficiaryDetail from "./projects/ProjectBeneficiaryDetail"
import ProjectUpload from "./projects/ProjectUpload"
import ProjectNotification from "./projects/ProjectNotification"
import CaptureSiteVisit from "./projects/CaptureSiteVisit"
import ProjectSiteVisit from "./projects/ProjectSiteVisit"
import ProjectMilestoneNotification from "./projects/ProjectMilestoneNotification"

import IDVerificationPortal from "./etqa/IDVerificationPortal/IDVerificationPortal";

//APP
import APPMaintenanceSearch from "./maintenance/APP/APPMaintenanceSearch";
import APPIndicator from "./maintenance/APP/APPIndicator";

class Routes extends Component {
    render() {
        return (
            <span>
                <Route path='/dashboard' component={Dashboard} />
                <Route path='/sdfdashboard' component={SDFDashboard} />
                <Route path='/stakeholderdashboard' component={StakeholderDashboard} />
                <Route path='/skillsdashboard' component={SkillsDashboard} />
                <Route path='/employers' component={EmployerSearch} />
                <Route path='/employer' component={Employer} />
                <Route path='/employerLearners' component={EmployerLearnerSearch} />
                <Route path='/employerUsers' component={EmployerUserSearch} />
                <Route path='/employerContacts' component={EmployerContactSearch} />
                <Route path='/EmployerResearchVisitSearch' component={EmployerResearchVisitSearch} />
                <Route path='/ResearchVisitDashboardSearch' component={ResearchVisitDashboardSearch} />
                <Route path='/SurveySearch' component={SurveySearch} />
                <Route path='/AddSurvey' component={AddSurvey} />
                <Route path='/ViewSurvey' component={ViewSurvey} />
                <Route path='/SurveyDashboardSearch' component={SurveyDashboardSearch} />
                <Route path='/learners' component={LearnerSearch} />
                <Route path='/learner' component={Learner} />
                <Route path='/addLearnerSkillsProgram' component={AddLearnerSkillsProgram} />
                <Route path='/addLearnerBursary' component={AddLearnerBursary} />
                <Route path='/addLearnerInternships' component={AddLearnerInternships} />
                <Route path='/addLearnerLearnership' component={AddLearnerLearnership} />
                <Route path='/QCTOaddLearnerLearnership' component={QCTOAddLearnerLearnership} />
                <Route path='/addLearnerQualification' component={AddLearnerQualification} />
                <Route path='/LearnerQualificationUSSearch' component={LearnerQualificationUSSearch} />
                <Route path='/addLearnerUnitStandard' component={AddLearnerUnitStandard} />
                <Route path='/addLearnerTrade' component={AddLearnerTrade} />
                <Route path='/addLearnerAET' component={AddLearnerAET} />
                <Route path='/addLearnerFET' component={AddLearnerFET} />
                <Route path='/addLearnerCandidacy' component={AddLearnerCandidacy} />
                <Route path='/LearnerSkillsProgrammeSearch' component={LearnerSkillsProgrammeSearch} />
                <Route path='/LearnerBursarySearch' component={LearnerBursarySearch} />
                <Route path='/LearnerAETSearch' component={LearnerAETSearch} />
                <Route path='/LearnerFETSearch' component={LearnerFETSearch} />
                <Route path='/LearnerLearnershipSearch' component={LearnerLearnershipSearch} />
                <Route path='/LearnerQCTOLearnershipSearch' component={QCTOLearnerLearnershipSearch} />
                <Route path='/LearnerTradeSearch' component={LearnerTradeSearch} />
                <Route path='/learnerTradeTestSearch' component={LearnerTradeTestSearch} />
                <Route path='/LearnerInternshipsSearch' component={LearnerInternshipsSearch} />
                <Route path='/LearnerQualificationSearch' component={LearnerQualificationSearch} />
                <Route path='/LearnerCandidacySearch' component={LearnerCandidacySearch} />
                <Route path='/LearnerUnitStandardSearch' component={LearnerUnitStandardSearch} />
                <Route path='/LearnerLearnershipAchievements' component={LearnerLearnershipAchievements} />
                <Route path='/QCTOLearnerLearnershipAchievements' component={QCTOLearnerLearnershipAchievements} />
                <Route path='/ViewLearnershipAssessment' component={ViewLearnershipAssessment} />
                <Route path='/ViewModuleLearnershipAssessment' component={ViewModuleLearnershipAssessment} />
                <Route path='/ViewSkillsProgrammeAssessment' component={ViewSkillsProgrammeAssessment} />
                <Route path='/ViewQualificationAssessment' component={ViewQualificationAssessment} />
                <Route path='/ViewUnitStandardAssessment' component={ViewUnitStandardAssessment} />
                <Route path='/LearnerUnitStandardAssessment' component={LearnerUnitStandardAssessment} />
                <Route path='/LearnerSkillsProgrammeAssessment' component={LearnerSkillsProgrammeAssessment} />
                <Route path='/LearnerQualificationAssessment' component={LearnerQualificationAssessment} />
                <Route path='/LearnerLearnershipAssessments' component={LearnerLearnershipAssessments} />
                <Route path='/LearnerQCTOLearnershipAssessments' component={LearnerQCTOLearnershipAssessments} />
                <Route path='/ViewSkillsProgrammeAchievementUS' component={ViewSkillsProgrammeAchievementUS} />
                <Route path='/ViewLearnershipAchievementUS' component={ViewLearnershipAchievementUS} />
                <Route path='/QCTOViewLearnershipAchievementUS' component={QCTOViewLearnershipAchievementUS} />
                <Route path='/ViewQualificationAchievementUS' component={ViewQualificationAchievementUS} />
                <Route path='/LearnerUnitStandardAchievements' component={LearnerUnitStandardAchievement} />
                <Route path='/LearnerQualificationAchievements' component={LearnerQualificationAchievement} />
                <Route path='/LearnerSkillsProgrammeAchievements' component={LearnerSkillsProgrammeAchievement} />
                <Route path='/learnerCRM' component={LearnerCRM} />
                <Route path='/persons' component={PersonSearch} />
                <Route path='/person' component={Person} />
                <Route path='/learnergrants' component={LearnerProgrammeGrants} />

                <Route path='/clientSearch' component={ClientsEmailsSearch} />

                <Route path='/moderatorSearch' component={ModeratorSearch} />
                <Route path='/Moderatorlearnership' component={Moderatorlearnership} />
                <Route path='/ModeratorSkillsProgramme' component={ModeratorSkillsProgramme} />
                <Route path='/moderatorQualification' component={ModeratorQualification} />
                <Route path='/moderatorUnitStandard' component={ModeratorUnitStandards} />
                <Route path='/moderatorProviderSearch' component={ModeratorProviderSearch} />
                <Route path='/moderatorCRM' component={ModeratorCRM} />
                <Route path='/uploadPerson' component={UploadPerson} />
                <Route path='/uploadLearnership' component={UploadLearnership} />
                <Route path='/uploadSkills' component={UploadSkills} />
                <Route path='/uploadBursaries' component={UploadBursaries} />
                <Route path='/uploadInternship' component={UploadInternship} />
                <Route path='/uploadAET' component={UploadAET} />
                <Route path='/uploadCandidacy' component={UploadCandidacy} />
                <Route path='/uploadFET' component={UploadFET} />
                <Route path='/uploadQualification' component={UploadQualification} />
                <Route path='/uploadUnitStandard' component={UploadUnitStandard} />
                <Route path='/uploadAchievement' component={UploadAchievement} />
                <Route path='/EmployerCRM' component={EmployerCRM} />

                <Route path='/OrganisationCRM' component={OrganisationCRM} />

                <Route path='/providerCRM' component={ProviderCRM} />

                <Route path='/AssessorSkillsProgrammeSearch' component={AssessorSkillsProgrammeSearch} />
                <Route path='/AssessorQualificationSearch' component={AssessorQualificationSearch} />
                <Route path='/AssessorRegistrationHistory' component={AssessorRegistrationHistory} />
                <Route path='/assessorLearnershipUnitStandards' component={AssessorLearnershipUSSearch} />
                <Route path='/Assessorlearnerships' component={AssessorLearnershipSearch} />
                <Route path='/moderatorRegistrationHistory' component={ModeratorRegistrationHistory} />
                <Route path='/AssessorUnitStandard' component={AssessorUnitStandards} />
                <Route path='/AssessorProviderSearch' component={AssessorProviderSearch} />
                <Route path='/AssessorRegistrationDetails' component={AssessorRegistrationDetails} />
                <Route path='/assessorCRM' component={AssessorCRM} />
                <Route path='/assessorIDDocument' component={AssessorIDDocument} />
                <Route path='/DGLetterCreationSearch' component={DGLetterCreationSearch} />
                <Route path='/DGLetterCreation' component={DGLetterCreation} />
                <Route path='/DGQueryReasonSearch' component={DGQueryReasonSearch} />
                <Route path='/DGQueryReason' component={DGQueryReason} />
                <Route path='/DGRejectionReasonSearch' component={DGRejectionReasonSearch} />
                <Route path='/DGRejectionReason' component={DGRejectionReason} />
                <Route path='/OnlineRegistrationTypeSelect' component={OnlineRegistrationTypeSelect} />
                <Route path='/OnlineRegistrationSecondryTypeSelect' component={OnlineRegistrationSecondryTypeSelect} />
                <Route path='/AddOnlineAssessorFlow' component={AddOnlineAssessorFlow} />
                <Route path='/OnlineAssessorApprovalSearch' component={OnlineAssessorApprovalSearch} />
                <Route path='/assessorapproval' component={AssessorApproval} />
                <Route path='/OnlineAssessorApprovalQualificationScope' component={OnlineAssessorApprovalQualificationScope} />
                <Route path='/OnlineAssessorApprovalSkillsProgrammeScope' component={OnlineAssessorApprovalSkillsProgrammeScope} />
                <Route path='/OnlineAssessorApprovalLearnershipScope' component={OnlineAssessorApprovalLearnershipScope} />
                <Route path='/OnlineAssessorApprovalDocuments' component={OnlineAssessorApprovalDocuments} />
                <Route path='/OnlineAssessorDetailsVerification' component={OnlineAssessorDetailsVerification} />
                <Route path='/AddOnlineModeratorFlow' component={AddOnlineModeratorFlow} />
                <Route path='/OnlineModeratorApprovalSearch' component={OnlineModeratorApprovalSearch} />
                <Route path='/moderatorapproval' component={ModeratorApproval} />
                <Route path='/OnlineModeratorApprovalQualificationScope' component={OnlineModeratorApprovalQualificationScope} />
                <Route path='/OnlineModeratorApprovalSkillsProgrammeScope' component={OnlineModeratorApprovalSkillsProgrammeScope} />
                <Route path='/OnlineModeratorApprovalLearnershipScope' component={OnlineModeratorApprovalLearnershipScope} />
                <Route path='/OnlineModeratorApprovalDocuments' component={OnlineModeratorApprovalDocuments} />
                <Route path='/OnlineModeratorDetailsVerification' component={OnlineModeratorDetailsVerification} />

                <Route path='/AddOnlineProviderFlow' component={AddOnlineProviderFlow} />
                <Route path='/OnlineProviderApprovalSearch' component={OnlineProviderApprovalSearch} />
                <Route path='/providerapproval' component={ProviderApproval} />
                <Route path='/OnlineProviderApprovalQualificationScope' component={OnlineProviderApprovalQualificationScope} />
                <Route path='/OnlineProviderApprovalSkillsProgrammeScope' component={OnlineProviderApprovalSkillsProgrammeScope} />
                <Route path='/OnlineProviderApprovalLearnershipScope' component={OnlineProviderApprovalLearnershipScope} />
                <Route path='/OnlineProviderApprovalDocuments' component={OnlineProviderApprovalDocuments} />
                <Route path='/OnlineProviderDetailsVerification' component={OnlineProviderDetailsVerification} />

                <Route path='/SkillsLetterCreationSearch' component={SkillsLetterCreationSearch} />
                <Route path='/SkillsLetterCreation' component={SkillsLetterCreation} />
                <Route path='/SkillsQueryReasonSearch' component={SkillsQueryReasonSearch} />
                <Route path='/SkillsQueryReason' component={SkillsQueryReason} />
                <Route path='/SkillsRejectionReasonSearch' component={SkillsRejectionReasonSearch} />
                <Route path='/SkillsRejectionReason' component={SkillsRejectionReason} />
                <Route path='/SkillsTNumberConversionSearch' component={SkillsTNumberConversionSearch} />
                <Route path='/SkillsTNumberConversion' component={SkillsTNumberConversion} />

                <Route path='/maintenanceTargets' component={BenefitsTargetsSearch} />
                <Route path='/CreateInterventionTitles' component={CreateInterventionTitles} />
                <Route path='/maintenanceInterventionTitles' component={InterventionTitlesSearch} />
                <Route path='/maintenanceBenefitDescriptions' component={BenefitsDescriptionsSearch} />
                <Route path='/BenefitsDescriptionSearchForm' component={CreateBenefitsDescriptionSearch} />
                <Route path='/Benefits' component={BenefitsTargetAddFormSearch} />

                <Route path='/maintenanceLinking' component={LinkingSearch} />
                <Route path='/maintenanceBenefitsUploading' component={BenefitsUpload} />

                <Route path='/EmailAdd' component={EmailAdd} />
                <Route path='/maintenanceEmail' component={ClientsEmailsSearch} />

                <Route path='/moderator' component={Moderator} />
                <Route path='/moderatorRegistrationDetails' component={ModeratorRegistrationDetails} />


                <Route path='/providerSearch' component={ProviderSearch} />
                <Route path='/provider' component={Provider} />
                <Route path='/outcome' component={Outcome} />
                <Route path="/providerMonitoringAndEvaluation" component={ProviderMonitoringAndEvaluation} />
                <Route path="/providerTrade" component={ProviderTrade} />
                <Route path='/providerContacts' component={ProviderContact} />
                <Route path='/providerSiteVisits' component={ProviderSiteVisitsSearch} />
                <Route path='/providerUsers' component={ProviderUsers} />
                <Route path='/providerAccreditationDetails' component={ProviderAccreditation} />
                <Route path='/providerLearner' component={ProviderLearner} />
                <Route path='/providerUnitStandardSearch' component={ProviderUnitStandards} />
                <Route path='/providerQualificationUSSearch' component={ProviderQualificationUSSearch} />
                <Route path='/providerQualificationsSearch' component={ProviderQualificationSearch} />
                <Route path='/providerSkillsProgrammeSearch' component={ProviderSkillsProgrammeSearch} />
                <Route path='/providerSkillsProgrammeUSSearch' component={ProviderSkillsProgrammeUSSearch} />
                <Route path='/providerLearnershipSearch' component={ProviderLearnershipSearch} />
                <Route path='/providerLearnershipUSSearch' component={ProviderLearnershipUSSearch} />
                <Route path='/providerAssessorSearch' component={ProviderAssessorSearch} />
                <Route path='/providerModeratorSearch' component={ProviderModeratorSearch} />
                <Route path="/providerAccreditationHistory" component={ProviderAccreditationHistory} />
                <Route path='/providerModuleQualificationsSearch' component={ProviderModuleQualificationsSearch} />


                <Route path='/learnerSkillsProgram' component={LearnerSkillsProgram} />

                <Route path='/bda' component={BDASearch} />
                <Route path='/personSearch' component={PersonSearch} />
                <Route path='/externalmoderators' component={ExternalProviderSearch} />
                <Route path='/assessorSearch' component={AssessorSearch} />
                <Route path='/auditTrial' component={AuditTrial} />
                <Route path='/assessor' component={Assessor} />
                <Route path='/unitstandardsetupSearch' component={UnitStandardSetupSearch} />
                <Route path='/unitStandardSetup' component={UnitStandardSetup} />
                <Route path='/qualificationsetupSearch' component={QualificationSetupSearch} />
                <Route path='/qualificationsetup' component={QualificationSetup} />
                <Route path='/qualunitstandardsearch' component={QualificationUnitStandardSearch} />
                <Route path='/skillsProgramestandardsearch' component={SkillsUnitStandardSearch} />
                <Route path='/learnershipsetupSearch' component={LearnershipSetupSearch} />
                <Route path='/aetSetupSearch' component={AETSetupSearch} />
                <Route path='/AETsetup' component={AETSetup} />
                <Route path='/tradeSetupSearch' component={TradeSetupSearch} />
                <Route path='/Tradesetup' component={TradeSetup} />
                <Route path='/learnershipUnitStandardSearch' component={LearnershipUnitStandardSearch} />
                <Route path='/learnershipsetup' component={LearnershipSetup} />
                <Route path='/saqaxmlimport' component={SAQAXMLImport} />
                <Route path='/shortcoursesetup' component={ShortCourseSetupSearch} />
                <Route path='/skillsProgrammeSetupSearch' component={SkillsProgramSetupSearch} />
                <Route path='/skillsProgrammeSetup' component={SkillsProgramSetup} />
                <Route path='/artisansetup' component={ArtisansSetupSearch} />
                <Route path='/addLearnerFlow' component={AddLearnerFlow} />
                <Route path='/addPersonFlow' component={AddPersonFlow} />
                <Route path='/addAssessorFlow' component={AddAssessorFlow} />
                <Route path='/addModderatorFlow' component={AddModeratorFlow} />
                <Route path='/roleMaintenanceSearch' component={RoleMaintenanceSearch} />
                <Route path='/userMaintenanceSearch' component={UserMaintenanceSearch} />
                <Route path='/modulesetupSearch' component={ModuleSetupSearch} />
                <Route path='/qualmodulesearch' component={QualificationModuleSearch} />
                <Route path='/moduleSetup' component={ModuleSetup} />

                <Route path='/userRole' component={UserRoleSearch} />


                <Route path='/userDetails' component={UserDetailsMaintenanceSearch} />

                <Route path='/LinkingSearch' component={CreateLinkingSearch} />

                <Route path='/roleMaintenance' component={Role} />
                <Route path='/rolePermissionSearch' component={RolePermissionSearch} />
                <Route path='/rolePermissionMaintenance' component={RolePermission} />
                <Route path='/SDFSearch' component={SDFSearch} />
                <Route path='/sdf' component={SDF} />
                <Route path='/sdfOrgDetails' component={SDFOrganisationDetails} />

                {/*DG Application*/}

                <Route path='/DGOrganisationSearch' component={DGOrganisationSearch} />
                <Route path='/DGOrganisation' component={DGOrganisation} />
                <Route path='/DGApplication' component={DGApplication} />
                <Route path='/DGApplicationDashboard' component={DGApplicationDashboard} />
                <Route path='/DGOrganisationContacts' component={DGOrganisationContact} />
                <Route path='/DGDocumentUploads' component={DGDocumentsUpload} />
                <Route path='/dgForms' component={DGForms} />
                <Route path='/DGVerificationSearch' component={DGVerificationSearch} />
                <Route path='/DGVerificationMain' component={DGVerificationMain} />
                <Route path='/DGEvaluationSearch' component={DGEvaluationSearch} />
                <Route path='/DGEvaluationMain' component={DGEvaluationMain} />
                <Route path='/DGApprovalSearch' component={DGApprovalSearch} />
                <Route path='/DGApprovalMain' component={DGApprovalMain} />
                <Route path="/DGContracts" component={DGContracts} />
                <Route path="/Artisan2022" component={ArtisanForm2022} />
                <Route path="/AET2022" component={AETForm2022} />
                <Route path="/Bursary2022" component={BursaryForm2022} />
                <Route path="/Learnership2022" component={LearnershipForm2022} />
                <Route path="/Candidacy2022" component={CandidacyForm2022} />
                <Route path="/TVET2022" component={TVETForm2022} />
                <Route path="/LearnershipRPL2022" component={LearnershipRPLForm2022} />
                <Route path="/Internship2022" component={InternshipForm2022} />
                <Route path="/SkillsProgramme2022" component={SkillsProgrammeForm2022} />
                <Route path="/SkillsProgrammeEU2022" component={SkillsProgrammeEUForm2022} />
                <Route path="/WorkExperience2022" component={WorkExperienceForm2022} />

                {/*DG Forms 2024*/}
                <Route path="/Bursary2024" component={BursaryForm2024} />
                {/*DG Forms 2026*/}
                <Route path="/Artisan2026" component={ArtisanForm2026} />
                <Route path="/AET2026" component={AETForm2026} />
                <Route path="/Bursary2026" component={BursaryForm2026} />
                <Route path="/Learnership2026" component={LearnershipForm2026} />
                <Route path="/Candidacy2026" component={CandidacyForm2026} />
                <Route path="/TVET2026" component={TVETForm2026} />
                <Route path="/LearnershipRPL2026" component={LearnershipRPLForm2026} />
                <Route path="/Internship2026" component={InternshipForm2026} />
                <Route path="/SkillsProgrammeEU2026" component={SkillsProgrammeEUForm2026} />
                <Route path="/WorkExperience2026" component={WorkExperienceForm2026} />

                {/*QALPDashboard*/}
                <Route path='/qalpdashboard' component={QALPDashboard} />

                {/*MG DASHBOARD*/}
                <Route path='/mgdashboard' component={MGDashboard} />

                {/*DG DASHBOARD*/}
                <Route path='/dgdashboard' component={DGDashboard} />

                {/*APP DASHBOARD*/}
                <Route path='/appdashboard' component={APPDashboard} />

                {/*APP DASHBOARD*/}
                <Route path='/appsummarydashboard' component={APPSummaryDashboard} />


                <Route path='/StakeholderSearch' component={StakeholderSearch} />
                <Route path='/Stakeholder' component={Stakeholder} />
                <Route path='/StakeholderOrganisationDetails' component={StakeholderOrganisationDetails} />
                <Route path='/DGOrganisationStakeholder' component={OrganisationStakeholder} />
                <Route path='/DGOrganisationCRM' component={DGOrganisationCRM} />

                {/*End DG Application*/}

                <Route path='/skillsOrganisationSearch' component={OrganisationSearch} />
                <Route path='/skillsOrganisation' component={Organisation} />
                <Route path='/skillsChildOrganisation' component={ChildOrganisation} />
                <Route path='/skillsOrganisationContacts' component={OrganisationContact} />
                <Route path='/skillsOrganisationBankingDetails' component={OrganisationBankingDetails} />
                <Route path='/skillsChildOrganisationSearch' component={ChildOrganisationSearch} />
                <Route path='/skillsOrganisationCFODetails' component={OrganisationCFODetails} />
                <Route path='/skillsTrainingCommitteeSearch' component={TrainingCommitteeSearchRecord} />
                <Route path='/skillsTrainingCommittee' component={TrainingCommittee} />
                <Route path='/skillsUnion' component={UnionSearchRecord} />
                <Route path='/skillsOrganisationSDF' component={OrganisationSDF} />
                <Route path='/skillsOrganisationLevies' component={OrganisationGrantsLevies} />
                <Route path='/Levies' component={Levies} />
                <Route path='/skillsOrganisationGrants' component={Grants} />
                <Route path='/skillsOrganisationDiscretionaryGrants' component={DiscretionaryGrants} />
                <Route path='/skillsOrganisationInterSetaTransfer' component={InterSetaTransfer} />
                <Route path='/skillsOrganisationLetter' component={SDFComplianceLetter} />

                <Route path='/EmployerFileImport' component={EmployerFileImport} />

                <Route path="/WspAtrForms" component={WspAtrForms} />
                <Route path="/EmploymentNumber2022" component={EmploymentNumberForm2022} />
                <Route path="/EmploymentNumberSmall2022" component={EmploymentNumberSmallForm2022} />
                <Route path="/AnnualTrainingReport2022" component={AnnualTrainingReportForm2022} />
                <Route path="/ActualPivotalTraining2022" component={ActualPivotalTrainingForm2022} />
                <Route path="/WorkplaceSkillsPlan2022" component={WorkplaceSkillsPlanForm2022} />
                <Route path="/QualificationProfile2022" component={QualificationProfileForm2022} />
                <Route path="/PlannedPivotalTraining2022" component={PlannedPivotalTrainingForm2022} />
                <Route path="/ActualBeneficiariesTraining2022" component={ActualBeneficiariesTrainingForm2022} />
                <Route path="/ActualAET2022" component={ActualAETForm2022} />
                <Route path="/PlannedBeneficiariesTraining2022" component={PlannedBeneficiariesTrainingForm2022} />
                <Route path="/ProvincialDetails2022" component={ProvincialDetailsForm2022} />
                <Route path="/PlannedAET2022" component={PlannedAETForm2022} />
                <Route path="/ImpactAssessment2022" component={ImpactAssessmentForm2022} />
                <Route path="/HardToFillVacancies2022" component={HardToFillVacanciesForm2022} />
                <Route path="/CheckList2022" component={CheckListForm2022} />
                <Route path="/EmploymentNumber2023" component={EmploymentNumberForm2023} />
                <Route path="/EmploymentNumberSmall2023" component={EmploymentNumberSmallForm2023} />
                <Route path="/AnnualTrainingReport2023" component={AnnualTrainingReportForm2023} />
                <Route path="/ActualPivotalTraining2023" component={ActualPivotalTrainingForm2023} />
                <Route path="/WorkplaceSkillsPlan2023" component={WorkplaceSkillsPlanForm2023} />
                <Route path="/QualificationProfile2023" component={QualificationProfileForm2023} />
                <Route path="/PlannedPivotalTraining2023" component={PlannedPivotalTrainingForm2023} />
                <Route path="/ActualBeneficiariesTraining2023" component={ActualBeneficiariesTrainingForm2023} />
                <Route path="/ActualAET2023" component={ActualAETForm2023} />
                <Route path="/PlannedBeneficiariesTraining2023" component={PlannedBeneficiariesTrainingForm2023} />
                <Route path="/ProvincialDetails2023" component={ProvincialDetailsForm2023} />
                <Route path="/PlannedAET2023" component={PlannedAETForm2023} />
                <Route path="/ImpactAssessment2023" component={ImpactAssessmentForm2023} />
                <Route path="/HardToFillVacancies2023" component={HardToFillVacanciesForm2023} />
                <Route path="/CheckList2023" component={CheckListForm2023} />
                <Route path="/wspAtrDashboard" component={WspAtrDashboard} />
                <Route path="/WspAtrDocumentsUpload" component={WspAtrDocumentsUpload} />
                <Route path="/WSPATRVerificationMain" component={WSPATRVerificationMain} />
                <Route path="/WspAtrVerification" component={WspAtrVerification} />
                <Route path="/WSPATREvaluation" component={WSPATREvaluation} />
                <Route path="/WSPATREvaluationMain" component={WSPATREvaluationMain} />
                <Route path="/WSPATRApprovalMain" component={WSPATRApprovalMain} />
                <Route path="/WspAtrApproval" component={WspAtrApproval} />
                <Route path="/Approval" component={Approval} />
                <Route path="/Evaluation" component={Evaluation} />
                <Route path="/Verification" component={Verification} />
                <Route path="/StakeholderFeedback" component={Feedback} />
                <Route path="/WspAtrLodgeApeal" component={LodgeApeal} />
                <Route path="/WspAtrExtensionRequest" component={RequestExtension} />

                {/*WSP/ATR Forms 2024*/}
                <Route path="/EmploymentNumber2024" component={EmploymentNumberForm2024} />
                <Route path="/EmploymentNumberSmall2024" component={EmploymentNumberSmallForm2024} />
                <Route path="/AnnualTrainingReport2024" component={AnnualTrainingReportForm2024} />
                <Route path="/ActualPivotalTraining2024" component={ActualPivotalTrainingForm2024} />
                <Route path="/WorkplaceSkillsPlan2024" component={WorkplaceSkillsPlanForm2024} />
                <Route path="/QualificationProfile2024" component={QualificationProfileForm2024} />
                <Route path="/PlannedPivotalTraining2024" component={PlannedPivotalTrainingForm2024} />
                <Route path="/ActualBeneficiariesTraining2024" component={ActualBeneficiariesTrainingForm2024} />
                <Route path="/ActualAET2024" component={ActualAETForm2024} />
                <Route path="/PlannedBeneficiariesTraining2024" component={PlannedBeneficiariesTrainingForm2024} />
                <Route path="/ProvincialDetails2024" component={ProvincialDetailsForm2024} />
                <Route path="/PlannedAET2024" component={PlannedAETForm2024} />
                <Route path="/ImpactAssessment2024" component={ImpactAssessmentForm2024} />
                <Route path="/HardToFillVacancies2024" component={HardToFillVacanciesForm2024} />
                <Route path="/CheckList2024" component={CheckListForm2024} />

                {/*WSP/ATR Forms 2025*/}
                <Route path="/EmploymentNumber2025" component={EmploymentNumberForm2025} />
                <Route path="/EmploymentNumberSmall2025" component={EmploymentNumberSmallForm2025} />
                <Route path="/AnnualTrainingReport2025" component={AnnualTrainingReportForm2025} />
                <Route path="/ActualPivotalTraining2025" component={ActualPivotalTrainingForm2025} />
                <Route path="/WorkplaceSkillsPlan2025" component={WorkplaceSkillsPlanForm2025} />
                <Route path="/QualificationProfile2025" component={QualificationProfileForm2025} />
                <Route path="/PlannedPivotalTraining2025" component={PlannedPivotalTrainingForm2025} />
                <Route path="/ActualBeneficiariesTraining2025" component={ActualBeneficiariesTrainingForm2025} />
                <Route path="/ActualAET2025" component={ActualAETForm2025} />
                <Route path="/PlannedBeneficiariesTraining2025" component={PlannedBeneficiariesTrainingForm2025} />
                <Route path="/ProvincialDetails2025" component={ProvincialDetailsForm2025} />
                <Route path="/PlannedAET2025" component={PlannedAETForm2025} />
                <Route path="/ImpactAssessment2025" component={ImpactAssessmentForm2025} />
                <Route path="/HardToFillVacancies2025" component={HardToFillVacanciesForm2025} />
                <Route path="/CheckList2025" component={CheckListForm2025} />

                {/*WSP/ATR Forms 2026*/}
                <Route path="/EmploymentNumber2026" component={EmploymentNumberForm2026} />
                <Route path="/EmploymentNumberSmall2026" component={EmploymentNumberSmallForm2026} />
                <Route path="/AnnualTrainingReport2026" component={AnnualTrainingReportForm2026} />
                <Route path="/ActualPivotalTraining2026" component={ActualPivotalTrainingForm2026} />
                <Route path="/WorkplaceSkillsPlan2026" component={WorkplaceSkillsPlanForm2026} />
                <Route path="/QualificationProfile2026" component={QualificationProfileForm2026} />
                <Route path="/PlannedPivotalTraining2026" component={PlannedPivotalTrainingForm2026} />
                <Route path="/ActualBeneficiariesTraining2026" component={ActualBeneficiariesTrainingForm2026} />
                <Route path="/ActualAET2026" component={ActualAETForm2026} />
                <Route path="/PlannedBeneficiariesTraining2026" component={PlannedBeneficiariesTrainingForm2026} />
                <Route path="/ProvincialDetails2026" component={ProvincialDetailsForm2026} />
                <Route path="/PlannedAET2026" component={PlannedAETForm2026} />
                <Route path="/ImpactAssessment2026" component={ImpactAssessmentForm2026} />
                <Route path="/HardToFillVacancies2026" component={HardToFillVacanciesForm2026} />
                <Route path="/CheckList2026" component={CheckListForm2026} />


                <Route path='/ETQAReportSearch' component={ETQAReportSearch} />
                <Route path='/ETQAReport' component={ETQAReport} />
                <Route path='/SkillsReportSearch' component={SkillsReportSearch} />
                <Route path='/SkillsReport' component={SkillsReport} />
                <Route path='/MasterFileSearch' component={MasterFileSearch} />
                <Route path='/MasterFile' component={MasterFile} />
                <Route path='/SETMISFileSearch' component={SETMISFileSearch} />
                <Route path='/SETMISFile' component={SETMISFile} />
                <Route path='/DGReportSearch' component={DGReportSearch} />
                <Route path='/DGReport' component={DGReport} />
                <Route path='/CustomReports' component={CustomReports} />
                <Route path='/CustomReportsV2' component={CustomReportsV2} />
                <Route path='/AdminReportSearch' component={AdminReportSearch} />
                <Route path='/AdminReport' component={AdminReport} />
                <Route path='/ProviderReportSearch' component={ProviderReportSearch} />
                <Route path='/ProviderReport' component={ProviderReport} />
                <Route path='/EmployerReportSearch' component={EmployerReportSearch} />
                <Route path='/EmployerReport' component={EmployerReport} />

                <Route path="/providerDocuments" component={ProviderDocuments} />
                <Route path="/assessorDocuments" component={AssessorDocuments} />
                <Route path="/moderatorDocuments" component={ModeratorDocuments} />
                <Route path="/learnerDocuments" component={LearnerDocuments} />
                <Route path="/bulkApproval" component={BulkApproval} />
                <Route path="/expiryNotification" component={ExpiryNotification} />
                <Route path="/learnerendorsementletter" component={LearnerEndorsementLetter} />
                <Route path="/ProofOfRegistration" component={POR} />

                <Route path='/GrantSetupSearch' component={GrantSetupSearch} />
                <Route path='/AddEditTranche' component={AddEditTranche} />
                <Route path='/TrancheDetails' component={TrancheDetails} />
                <Route path='/ProcessingNav' component={ProcessingNav} />
                <Route path='/GenerateClaim' component={GenerateClaimSearch} />
                <Route path='/ApproveClaim' component={ApproveClaimSearch} />
                <Route path='/GrantClaimFormReversal' component={GrantClaimFormReversalSearch} />
                <Route path='/DownloadClaim' component={DownloadClaimSearch} />
                <Route path='/GenerateBatch' component={GenerateBatchSearch} />
                <Route path='/DownloadBatch' component={DownloadBatchSearch} />
                <Route path='/AXProcessor' component={AXProcessorSearch} />
                <Route path='/GrantReversals' component={GrantReversalsSearch} />
                <Route path='/BulkGrantAssociation' component={BulkGrantAssociation} />
                <Route path='/BulkGrantDeAssociation' component={BulkGrantDeAssociation} />

                {/*Helpdesk*/}
                <Route path='/HelpdeskRequestSearch' component={HelpdeskRequestSearch} />
                <Route path='/HelpdeskRequest' component={HelpdeskRequest} />
                <Route path='/HelpDeskReport' component={HelpDeskReport} />
                

                {/*End Helpdesk*/}

                <Route path='/AudienceOptions' component={AudienceOptions} />
                <Route path='/BulkEmailSearch' component={BulkEmailSearch} />
                <Route path='/BulkEmailDetail' component={BulkEmailDetail} />

                <Route path='/ProjectsSearch' component={ProjectsSearch} />
                <Route path='/NewProject' component={NewProject} />
                <Route path='/ProjectDetail' component={ProjectDetail} />
                <Route path='/ProjectMilestone' component={ProjectMilestone} />
                <Route path='/CaptureMilestone' component={CaptureMilestone} />
                <Route path='/ProjectBudget' component={ProjectBudget} />
                <Route path='/ProjectGrant' component={ProjectGrant} />
                <Route path='/ProjectBeneficiaries' component={ProjectBeneficiaries} />
                <Route path='/ProjectBeneficiaryDetail' component={ProjectBeneficiaryDetail} />
                <Route path='/ProjectUpload' component={ProjectUpload} />
                <Route path='/ProjectNotification' component={ProjectNotification} />
                <Route path='/CaptureSiteVisit' component={CaptureSiteVisit} />
                <Route path='/ProjectSiteVisit' component={ProjectSiteVisit} />
                <Route path='/ProjectMilestoneNotification' component={ProjectMilestoneNotification} />

                <Route path='/IDVerificationPortal' component={IDVerificationPortal} />
                {/*APP*/}
                <Route path='/APPMaintenanceSearch' component={APPMaintenanceSearch} />
                <Route path='/APPIndicator' component={APPIndicator} />

            </span>
        );
    }
}

export default withRouter(connect()(Routes));
